import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting/routes_names';
import USER_PERMISSIONS from '@/utils/constants/accounting/permissions_aliases';

const actions = [
    {
        routeName: ROUTES.GL_JOURNAL_ENTRIES.name,
        items: [
            {
                title: 'add new entries',
                routeName: ROUTES.GL_JOURNAL_ENTRIES_ADD_NEW_ENTRIES.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_JOURNAL_ENTRY);
                },
            },
        ],
    },
];

export default actions;
